import { Stack } from "@mui/system";

export const VStack = ({ children, ...props }) => {
  return (
    <Stack direction="column" display={"flex"} {...props}>
      {children}
    </Stack>
  );
};
